import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { joinGroup as joinGroupModel } from 'APP/model/group/groupModel';
import { IPersonalizedGroup } from 'APP/model/group/groupModel.types';
import { SpaceUserRole } from 'APP/model/space/spaceModel.types';
import { GroupServerErrorCode } from 'APP/restApi/constants/group.errors';
import Entities from 'STORE';

import { loadSpace } from '../../space/loadSpace/loadSpace';
import { setActiveGroup } from '../setActiveGroup/setActiveGroup';

async function request(groupId: string): Promise<IPersonalizedGroup | null> {
  try {
    return await joinGroupModel(groupId);
  } catch (error) {
    //TODO: move to the presenter logic
    if (error.message === GroupServerErrorCode.UserIsBannedInTheGroup) {
      Tasks.app.showAlert(t('banned_user_deeplink_error'));
    } else if (error.message === GroupServerErrorCode.GroupDoesNotExist) {
      Tasks.app.showAlert(t('common_chat_is_not_accessible'));
    }

    if (groupId === Entities.GroupsStore.activeGroupId) {
      setActiveGroup({ groupId: null });
    }
  }

  return null;
}

export async function joinGroup({ groupId }: { groupId: string }): Promise<boolean> {
  const personalizedGroup = await request(groupId);

  if (!personalizedGroup) {
    return false;
  }

  Entities.GroupsStore.merge([personalizedGroup]);

  const spaceId = personalizedGroup.groupResponse?.spaceId;

  if (spaceId) {
    const space = Entities.spacesStore.getById(spaceId);

    if (space) {
      space.isGuest && space.setRole(SpaceUserRole.Member);
    } else {
      await loadSpace(spaceId, false);
    }
  }

  return true;
}
